import { createApp } from "vue";
import App from "./App.vue";
import router from "./routes";
import BaseCard from "./components/BaseCard.vue";
import BaseDetail from "./components/BaseDetail.vue";
import Vue3Lottie from "vue3-lottie";

const app = createApp(App);
app.use(router);
app.use(Vue3Lottie);
app.component("base-card", BaseCard);
app.component("base-detail", BaseDetail);
app.mount("#app");
